import React, { useState, useRef, useEffect } from "react";
import "./read-more-content.css";

function ReadMoreContent({ content = "", fontSize = "14px" }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const [showReadMoreBtn, setShowReadMoreBtn] = useState(true);
  const contentRef = useRef(null);
  const descriptionArray = content.split("\r\n");

  useEffect(() => {
    // Check if content overflows and decide whether to show the "Read More" button
    const pTag = document.createElement("p");
    pTag.style.fontSize = fontSize;
    pTag.style.marginBottom = "0px";
    pTag.style.visibility = "hidden";
    pTag.style.position = "absolute";
    pTag.innerHTML = content.replace(/\r\n/g, "<br />");

    const heightCheckContainer = document.getElementById(
      "height-check-container"
    );
    heightCheckContainer.style.position = "relative";
    heightCheckContainer.appendChild(pTag);

    const currentHeight = contentRef.current?.offsetHeight;
    const realHeight = pTag.offsetHeight;

    if (realHeight > currentHeight) {
      setIsExpanded(false);
    }

    if (realHeight <= currentHeight) {
      setShowReadMoreBtn(false);
    }

    // heightCheckContainer.removeChild(pTag);
  }, [content]);

  const handleExpandClick = () => {
    setIsExpanded((oldExpand) => {
      if (oldExpand) {
        contentRef.current.style.WebkitLineClamp = "var(--read-more-max-lines)";
      } else {
        contentRef.current.style.WebkitLineClamp = "unset";
      }
      return !oldExpand;
    });
  };

  const btnText = isExpanded ? "Read less" : "Read more";

  return (
    <>
      <p ref={contentRef} className="read-more-content">
        {descriptionArray.map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </p>
      <div id="height-check-container"></div>
      {showReadMoreBtn && (
        <button onClick={handleExpandClick} className="read-more-content-btn">
          {btnText}
        </button>
      )}
    </>
  );
}

export default ReadMoreContent;
